<template>
  <v-container fluid>
    <v-card class="mb-8">
      <v-data-table
        :loading="application_admin_loading"
        loading-text="Записи загружаются..."
        :headers="headers"
        :items="application_admin"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title class="headline font-weight-light">Панель администратора</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              :append-icon="icons.mdiMagnify"
              label="Поиск"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:item.id="{ item }">
          <router-link :to="
            {
              name: 'operator_check_application',
              params: {id: item.id}
            }
          ">
            {{item.id}}
          </router-link>
        </template>
        <template v-slot:item.abiturient.last_name="{ item }">
          {{ item.abiturient.last_name +' ' + item.abiturient.first_name }}
        </template>
        <template v-slot:item.operator.user.last_name="{ item }">
          <span v-if="item.operator === null"></span>
          <span v-else>{{ item.operator.user.last_name + ' '+ item.operator.user.first_name }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {mdiMagnify} from "@mdi/js";

  export default {
    name: "Admin",
    data:
      () => ({
        icons: {
          mdiMagnify
        },
        application_admin: [],
        search: '',
        headers: [
          {
            text: 'Приемная компания',
            align: 'start',
            sortable: false,
            value: 'campaign.city'
          },
          {text: '№ заявления', value: 'id'},
          {text: 'Тип заявления', value: 'application_type.education_level_name'},
          {text: 'Поступающий', value: 'abiturient.last_name'},
          {text: 'Email', value: 'abiturient.email'},
          {text: 'Состояние', value: 'status'},
          {text: 'Оператор', value: 'operator.user.last_name'}
        ],
      }),
    methods: {
      async initData() {
        await this.$store.dispatch("operator/loadApplicationsAdmin")
          .then(() => {
            this.application_admin = this.$store.getters["operator/application_admin"]
          })
      }
    },
    computed: {
      ...mapGetters("operator", ["application_admin_loading"]),
      ...mapGetters("auth", ["user"])
    },
    async beforeRouteEnter(to, from, next) {
      await next(vm => vm.initData())
    },
  };
</script>

<style scoped>

</style>


<!--
import Store from '@/_store'

async beforeRouteEnter(to, from, next) {
      await Store.dispatch("operator/loadApplicationsAdmin")
        .then(() => {
          next()
        });
-->
